import { useQuery } from "@tanstack/vue-query";
import { type Ref, computed } from "vue";

import type { Newsletter } from "@/types/newsletter";

import type { SubscriptionState } from "../lib";

interface SniperLinkData {
  url: string;
  image: string;
  provider_pretty: string;
}

export function useSniperLink(
  emailAddress: Ref<string>,
  newsletter: Newsletter,
  state: Ref<SubscriptionState>
) {
  const senderEmail = computed(() => {
    return newsletter.email_domain
      ? newsletter.email_address
      : `${newsletter.username}@buttondown.email`;
  });

  const { data } = useQuery({
    queryKey: computed(() => [
      "sniper-link",
      emailAddress.value,
      senderEmail.value,
    ]),
    enabled: computed(() => {
      return state.value === "unactivated" && !!emailAddress.value;
    }),
    async queryFn({ signal }): Promise<SniperLinkData | null> {
      const response = await fetch(
        `https://sniperl.ink/v1/render?recipient=${encodeURIComponent(
          emailAddress.value
        )}&sender=${encodeURIComponent(senderEmail.value)}`,
        { signal }
      );
      if (response.ok) return response.json();
      if (response.status === 404) return null;
      throw new Error(`Failed to fetch sniper link: ${response.status}`);
    },
    retry: false,
  });

  return { data };
}
